import { ocrState, isPlayingState, isPremiumState } from '@/store'
import { Camera, HelpCircle } from 'react-feather'
import { useState, useEffect } from 'react'
import { useRecoilState } from 'recoil'
import api from '@/utils/api'
import analytics from '@/utils/analytics'
import { hideAllTooltips } from '@/utils/index'
import toast from 'react-hot-toast'
import Button from '@/components/Button'
import {
  useShowOcrModal,
  useShowInstallExtensionModal,
} from '@/components/Modal'
import ReactTooltip from 'react-tooltip'

const chromeExtensionId = 'mepbiloikmgpehamobkanmcllidclden'

export default function OcrButton({ content, onContentChange, className }) {
  const [wasPaused, setWasPaused] = useState(false)
  const [isLoadingOcr, setIsloadingOcr] = useState(false)
  const [ocr, setOcr] = useRecoilState(ocrState)
  const [isPlaying, setIsPlaying] = useRecoilState(isPlayingState)
  const [isPremium] = useRecoilState(isPremiumState)
  const showOcrModal = useShowOcrModal()
  const showInstallExtensionModal = useShowInstallExtensionModal()

  useEffect(() => {
    if (!ocr || !isPlaying) {
      return
    }

    setIsloadingOcr(true)

    try {
      setTimeout(() => {
        window.chrome.runtime.sendMessage(
          chromeExtensionId,
          { event: 'GET_BASE_64' },
          function (base64) {
            setOcr(false)
            if (wasPaused) {
              setIsPlaying(false)
              setWasPaused(false)
            }
            getTextFromBase64(base64)
          }
        )
      }, 200)
    } catch (error) {
      setOcr(false)
      setIsloadingOcr(false)
    }
  }, [ocr, isPlaying])

  function onOcrClick() {
    hideAllTooltips()

    if (!isPremium) {
      analytics.track('(OCR) Not premium')
      showOcrModal()
      return
    }

    if (!window.chrome) {
      analytics.track('(OCR) Not using Chrome')
      toast.error('Please, use Chrome for this feature')
      return
    }

    try {
      window.chrome.runtime.sendMessage(
        chromeExtensionId,
        { event: 'CHECK_IF_EXISTS' },
        (exists) => {
          if (!exists) {
            analytics.track('(OCR) Chrome but not extension')
            showInstallExtensionModal()
            return
          }

          setOcr(true)
          if (!isPlaying) {
            setWasPaused(true)
            setIsPlaying(true)
          }
        }
      )
    } catch (error) {
      analytics.track('(OCR) Chrome but not extension')
      showInstallExtensionModal()
    }
  }

  async function getTextFromBase64(base64) {
    try {
      const response = await api.post('/ocr', {
        base64,
      })

      setIsloadingOcr(false)

      const textFromImage = response.data.data || ''
      const newContent = content
        ? `${content} \n\n ${textFromImage}`
        : textFromImage
      onContentChange({ text: newContent })
    } catch (error) {
      setIsloadingOcr(false)
    }
  }

  return (
    <>
      <Button
        data-tip
        data-for="ocr-button"
        isLoading={isLoadingOcr}
        onClick={onOcrClick}
        className={className}
        tabIndex={-1}
      >
        <Camera className="h-5 w-5" />
      </Button>

      <ReactTooltip
        place="top"
        effect="solid"
        id="ocr-button"
        clickable
        delayHide={100}
      >
        <span className="center">
          {`Text from video${isPremium ? '' : ' (Premium)'}`}
          <HelpCircle
            onClick={() => {
              analytics.track('(OCR) tooltip info clicked')
              showOcrModal()
            }}
            className="clickable-opacity ml-2 h-5 w-5"
          />
        </span>
      </ReactTooltip>
    </>
  )
}
